// @flow
export default from './CookieDisclaimer';



// WEBPACK FOOTER //
// ./components/CookieDisclaimer/index.js